module.exports = __webpack_public_path__ + "img/21_2.3af10a1b.png";